<mat-card>
  <mat-card-header>
    <mat-card-title>
      Server Logs
    </mat-card-title>

    <mat-card-subtitle>
      <div *ngIf="status">
        <div>Server Version: {{status.gitVersion}}</div>
        <div>Server Uptime: {{uptime.humanize()}}</div>
        <button mat-raised-button color="accent" (click)="viewStatus()">View Status</button>
      </div>
      <mat-form-field class="filter">
        <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
        <mat-hint>Comma seperate filter terms. (Eg. application, username)</mat-hint>
      </mat-form-field>
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Log Name Column -->
      <ng-container matColumnDef="logName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Log Name </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">Log Name:</span>
          {{element.logName}}
        </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="logDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">Date:</span>
          <div>
            <div>{{element.logDate|date:'mediumDate'}}</div>
            <div>{{element.logDate|date:'HH:mm:ss'}}</div>
          </div>
        </td>
      </ng-container>

      <!-- Request / IP Address Column -->
      <ng-container matColumnDef="request">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Request </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">IP:</span>
          <div>
            <div>{{element.ipAddress}}</div>
            <div>{{element.request}}</div>
          </div>
        </td>
      </ng-container>

      <!-- User Email Column -->
      <ng-container matColumnDef="userEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> User Email / Target User </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">User Email:</span>
          <div>
            <div *ngIf="element.userId && element.userId != 0">
              {{element.userEmail}}:{{element.userId}}
            </div>
            <div *ngIf="element.targetUserId && element.targetUserId != 0">
              {{element.targetUserEmail}}:{{element.targetUserId}}
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Target User Column -->
      <ng-container matColumnDef="targetUserEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Target User </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">Target User:</span>
          <div *ngIf="element.targetUserId && element.targetUserId != 0">
            {{element.targetUserEmail}}:{{element.targetUserId}}
          </div>
        </td>
      </ng-container>

      <!-- App Column -->
      <ng-container matColumnDef="applicationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Application </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">Application:</span>
          <div *ngIf="element.applicationId && element.applicationId != 0">
            {{element.applicationName}}:{{element.applicationId}}
          </div>
        </td>
      </ng-container>

      <!-- Details Column -->
      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Details </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-label">Details:</span>
          <div class="details">
            {{element.details}}
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <mat-spinner *ngIf="isLoading"></mat-spinner>

  </mat-card-content>

  <mat-card-actions align="end">
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </mat-card-actions>

</mat-card>